/*
 *
 *  #region Copyright (c), Crompton Greaves Consumer Electricals Ltd.
 *  Crompton R&D IoT Department Proprietary Software
 *
 *  This file is part of Crompton Smart Home SDK
 *  Copyright (c) 2024 Crompton Greaves Consumer Electricals Ltd. All rights reserved.
 *  Contact: CROMPTON DEVELOPER SUPPORT <iot.platform@crompton.co.in>
 *
 *  This software, including documentation, is protected by copyright by
 *  Crompton Greaves Consumer Electricals Ltd. All rights are reserved. Copying, including reproducing, storing,
 *  adapting or translating, any or all of this material requires the prior written consent of
 *  Crompton Greaves Consumer Electricals Ltd. This material also contains confidential information which should not
 *  be disclosed to others without the prior written consent of Crompton Greaves Consumer Electricals Ltd.
 *
 *  Filename :
 *  * Created on: <Date>
 *  Author    :
 *  * #endregion
 * /
 *
 */
import {IoHeart, IoHeartOutline, IoPencil} from "react-icons/io5";
import { useState } from "react";
import Card from "components/card";
import {MdEdit} from "react-icons/md";
import {useNavigate} from "react-router-dom";

const NftCard = ({ title, productCategory, productSubCategory, productId, image, createdTime, lastModified, bidders, extra, mfg, def }) => {
  const [heart, setHeart] = useState(true);
  const navigate = useNavigate();

  function editProductIconClicked(productId) {
    sessionStorage.setItem("mfg", mfg)
    sessionStorage.setItem("def", def)
    sessionStorage.setItem("createdTime", createdTime)
    sessionStorage.setItem("lastModified", lastModified)
    navigate("/admin/products/product-details/" + productId)
  }

  function getBackgroundColor(def) {
    return def === 0 ? 'bg-black' : 'bg-white';
  }
  return (
      <Card
          extra={`flex flex-col w-full h-full !p-4 3xl:p-![18px] ${def === 1 ? 'bg-blend-lighten' : 'bg-blue-50'}  ${extra}`} >
        <div className="h-full w-full">
          <div className="relative w-full">
            <img
                src={image}
                className={`mb-3 h-[80px] w-[80px] rounded-xl 3xl:h-[80px] 3xl:w-[80px] ${def === 0 ? 'bg-blue-50' : 'bg-blend-lighten'}`}
                alt=""
            />
            <button
                className="absolute top-3 right-3 flex items-center justify-center rounded-full p-2 text-[#004c86] transition duration-200 hover:cursor-pointer
                hover:bg-gray-100 active:bg-gray-50 dark:!border-none dark:bg-navy-700 dark:text-white
                dark:hover:bg-white/20 dark:active:bg-white/10" onClick={() => editProductIconClicked(productId)}
            >
              <div className="flex h-full w-full items-center justify-center rounded-full text-xl dark:text-[#ffffff] " onClick={() => editProductIconClicked(productId)}>
                <MdEdit/>
               {/* {heart ? (
                    <IoHeartOutline />
                ) : (
                    <IoHeart className="text-brand-500" />
                )}*/}
              </div>
            </button>
          </div>

          <div className="mb-3 flex items-center justify-between px-1 md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col xl:items-start 3xl:flex-row 3xl:justify-between">
            <div className="mb-2">
              <p className={`text-lg font-bold ${def === 1 ? 'text-navy-700' : 'text-gray-700'}`}>
                {" "}
                {title}{" "}
              </p>
              <p className="mt-1 text-sm font-medium text-gray-600 md:mt-2">
              Category: {productCategory}{" "} | Type: {productSubCategory}{" "}
              </p>
            </div>

            {/*<div className="flex flex-row-reverse md:mt-2 lg:mt-0">
            <span className="z-0 ml-px inline-flex h-8 w-8 items-center justify-center rounded-full border-2 border-white bg-[#E0E5F2] text-xs text-navy-700 dark:!border-navy-800 dark:bg-gray-800 dark:text-white">
              +5
            </span>
              {bidders.map((avt, key) => (
                  <span
                      key={key}
                      className="z-10 -mr-3 h-8 w-8 rounded-full border-2 border-white dark:!border-navy-800"
                  >
                <img
                    className="h-full w-full rounded-full object-cover"
                    src={avt}
                    alt=""
                />
              </span>
              ))}
            </div>*/}
          </div>

          <div className="flex items-center justify-between md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col 2xl:items-start 3xl:flex-row 3xl:items-center 3xl:justify-between">
            <div className="flex">
              <p className="mb-2 text-sm font-bold text-[#004c86] dark:text-white">
                Product Id: {productId} <span></span>
              </p>
            </div>
            {/*<button
                href=""
                className="rounded-[20px] bg-brand-900 px-4 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
            >
              Place Bid
            </button>*/}
          </div>

          <div className="mb-3 flex items-center justify-between px-1 md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col xl:items-start 3xl:flex-row 3xl:justify-between">
            <div className="mb-2">
              <p className="mt-1 text-sm font-medium text-gray-600 md:mt-2">
                Created Time : {" "}{createdTime}{" "}
              </p>
              <p className="mt-1 text-sm font-medium text-gray-600 md:mt-2">
                Last Modified : {" "}{lastModified}{" "}
              </p>
            </div>

            {/*<div className="flex flex-row-reverse md:mt-2 lg:mt-0">
            <span className="z-0 ml-px inline-flex h-8 w-8 items-center justify-center rounded-full border-2 border-white bg-[#E0E5F2] text-xs text-navy-700 dark:!border-navy-800 dark:bg-gray-800 dark:text-white">
              +5
            </span>
              {bidders.map((avt, key) => (
                  <span
                      key={key}
                      className="z-10 -mr-3 h-8 w-8 rounded-full border-2 border-white dark:!border-navy-800"
                  >
                <img
                    className="h-full w-full rounded-full object-cover"
                    src={avt}
                    alt=""
                />
              </span>
              ))}
            </div>*/}
          </div>
        </div>
      </Card>
  );
};

export default NftCard;
